<template>

  <div id="messages-filter">

    <f7-list>
      <!-- Sélection des valeurs de Filtre -->
      <f7-list-item :class="{'filter-item-section':true, 'd-none': !displayFilter}">
        <b-row style="min-width: 100%">
          <b-col cols="8" class="mb-3 filter-item px-0" offset="1" style="flex-direction: row">
            <span class="filter-item-title mt-1 mr-2">
              {{ $t('pain008.filter_status') }}
            </span>
            <a :id="'status-picker-link' + '-' + filterType + '-' + randomString" class="filter-item-content"
              style="min-height:24px!important" href="#">
              <i v-if="statusDisplay.icon" :class="statusDisplay.icon"></i>
              <div class="d-flex justify-content-between">
                <span :class="{'filter-item-input-complete':statusDisplay.nb > 0}">{{ statusDisplay.label }}</span>
                <i class="fa-light fa-chevron-down ml-4 mr-1" size="17px" id="status-chevron"></i>
              </div>
            </a>
            <b-popover :target="'status-picker-link' + '-' + filterType + '-' + randomString"
              :title="$t('filter.selected_status_none')"
              triggers="focus" placement="bottomright">
              <b-form-checkbox @change="selectAll()" v-model="allcheckedValid">
                {{ $t('pain008.select_all') }}
              </b-form-checkbox>
              <span v-for="Status in statusList" :key="Status.name">
                <b-form-checkbox v-model="Status.state" @change="decideLine()"
                  :value="1"
                  :unchecked-value="0">
                  <i :icon="Status.icon"></i>
                  <span>{{ Status.label }}</span>
                </b-form-checkbox>
              </span>
            </b-popover>
          </b-col>

          <b-col cols="1" class="mb-3 p-0">
            <b-button class="btn" size="sm" style="min-width:10px;min-height: 24px!important"
              @click="applyFilter(modeFilter)">
              <i class="fa-light fa-magnifying-glass"></i>
            </b-button>
          </b-col>
        </b-row>
      </f7-list-item>
    </f7-list>
  </div>

</template>

<script>
import datePickerMixin from '@/mixins/datePickerMixin'
import Status from '@/helpers/status.js'
import {statusLabel, statusIcon} from '@/helpers/labels.js'
import services from '@/helpers/services.js'

export default {
  mixins: [datePickerMixin],
  name: 'MessagesFilter',
  props: {
    filterType: {
      type: String,
      default: 'list'
    },
    mode: {
      type: Number,
      default: 1
    },
    propedServiceId: {
      type: String,
      default: 'none'
    },
    randomId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      allcheckedValid: false,
      dir: 0,
      displayFilter: true,
      hasDefaultFilter: false,
      Status: '',
      modeFilter: this.mode,
      services: services,
      statusList: [
        {
          code: 10,
          label: statusLabel(this.$i18n, Status.POSITIVE_RESPONSE),
          state: 0
        },
        {
         code: 2,
         label: statusLabel(this.$i18n, Status.REQUEST_BEING_PROCESSED),
         state: 0
        },
         {
          code: 11,
          label: statusLabel(this.$i18n, Status.NEGATIVE_RESPONSE),
          state: 0
        },
         {
          code: 12,
          label: statusLabel(this.$i18n, Status.EXPIRED_REQUEST),
          state: 0
        },
         {
          code: 6,
          label: statusLabel(this.$i18n, Status.BANK_UNREACHABLE),
          state: 0
        },
      ],
      randomString: '',
      serviceId: ''
    }
  },
  created () {
    if (this.propedServiceId === 'none') {
      this.serviceId = this.$engine.user.currentService.id
    } else {
      this.serviceId = this.propedServiceId
    }
    this.filterTypeGet = this.filterType

    this.$bus.on('service:change', (val) => {
      this.serviceId = this.$engine.getServiceIdByName(val)
    })
    this.$bus.emit('right-panel-set-feature', 'filter-messages')

    // Command "apply filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-apply-filter-' + this.randomId, (filter = {}) => {
      if (Object.keys(filter).length) {
        this.applyFilter(1, filter)
      } else {
        this.applyFilter()
      }
    })
    // Command "clear filter fields" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-clear-filter-fields', () => {
      this.clearFilterFields()
    })
    // Command "save filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-save-filter', () => {
      this.saveDefaultFilterData()
    })
    // Command "delete filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-delete-filter', () => {
      this.deleteFilter()
    })

    // Intercepts filter changes from the right-panel-filter-view (mobile)
    this.$bus.on('filter-update-fields', (filter) => {
      for (const property in filter) {
        if (this.statusList[property] !== undefined) {
          // Set filter status values
          this.statusList[property].state = filter[property]
        } else {
          // Set filter other values
          this[property] = filter[property]
        }
      }
    })
  },
  mounted () {
    this.dir = this.$settings.msgDirection
    this.randomString = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)

    let actualService = this.getActualService()
    var defaultFilter = {}
    switch (this.filterTypeGet) {
      case 'details':
        defaultFilter = actualService.filterDetails.getDefaultFilter()
        if (this.modeFilter === 2) {
          defaultFilter.statusDocRejected = 1
          defaultFilter.statusDocValidated = 1
        }
        break
      case 'draft':
        defaultFilter = actualService.filterDraft.getDefaultFilter()
        break
      case 'group':
        defaultFilter = actualService.filterGroup.getDefaultFilter()
        break
      case 'list':
        defaultFilter = actualService.filter.getDefaultFilter()
        break
      default:
        break
    }

    // Set default filter values
    this.setDefaultFilter(defaultFilter)

    // Warns right-panel-filter-view (mobile) that default values have been applied
    this.communicateChange()
  },
  beforeDestroy () {
    // this.$bus.emit('right-panel-clear-feature', 'filter-messages')
    this.$bus.off('service:change')
    this.$bus.off('filter-update-fields')
    this.$bus.off('filter-apply-filter-' + this.randomId)
    this.$bus.off('filter-save-filter')
    this.$bus.off('filter-delete-filter')

  },
  computed: {
    filterFields () {
      let that = this
      let filter = {}

      // Date, Reason and Name values
      filter.Status = this.Status

      // Status values
      for (let property in this.statusList) {
        let Status = that.statusList[property]
        filter[property] = Status.state
      }

      return filter
    },
    hasInputFilter () {
      if ((this.statusDisplay.nb > 0 && this.modeFilter !== 2) ||
        this.Status) {
        return true
      }
      return false
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    realStatusList () {
      let that = this
      const list = []
      for (const property in that.statusList) {
        const Status = that.statusList[property]
        list.push({
          tag: property,
          label: Status.label,
          icon: Status.icon,
          state: Status.state
        })
      }
      return list
    },
    statusDisplay () {
      let realStatusList = this.realStatusList.filter(Status => Status.state === 1)
      if (realStatusList.length === 0) {
        return {
          label: this.$t('filter.selected_status_none'),
          nb: 0
        }
      } else if (realStatusList.length === 1) {
        return {
          label: realStatusList[0].label,
          icon: realStatusList[0].icon,
          nb: 1
        }
      } else {
        let finalLabel
        if (realStatusList.length === this.realStatusList.length) {
          finalLabel = this.$t('pain008.select_all')
        } else {
          finalLabel = realStatusList[0].label
          for (let i = 1; i < realStatusList.length; i++) {
            finalLabel += ', ' + realStatusList[i].label
          }
        }
        return {
          label: finalLabel,
          nb: realStatusList.length
        }
      }
    }
  },
  methods: {
    allLineSelect () {
        let i = 0
        while ((i < this.statusList.length) && (this.statusList[i].state === 1)) {
          i++
        }
        if (i === this.statusList.length) {
          this.allcheckedValid = true
        }
    },
    applyFilter (mode = 1, filterConditions = {}) {
      let that = this
      let actualService = this.getActualService()
      let actualFilter = actualService.filter
      actualFilter.cleanFilterCondition()

      let statusSelected = []
      for (let property in this.statusList) {
        let Status = that.statusList[property]
        if(Status.state === 1) {
          statusSelected.push(Status.code)
          // statusSelected = Status.code
        }
        // actualFilter[property] = Status.state
      }
      actualFilter.Status = statusSelected
      actualFilter.modeFilter = mode

      for (let propertyCustom in filterConditions) {
        actualFilter[propertyCustom] = filterConditions[propertyCustom]
      }
      this.$emit('applyFilter', actualFilter.getConditionObject())
    },
    clearFilterFields () {
      let that = this
      for (let property in that.statusList) {
        that.statusList[property].state = 0
      }

      if (this.modeFilter === 2 && this.serviceId === services.DOCUMENTSERVICE) {
        that.statusList.statusDocRejected.state = 1
        that.statusList.statusDocValidated.state = 1
      }

      this.Status = ''
      this.communicateChange()
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    decideLine () {
      if (this.allcheckedValid) {
        this.allcheckedValid = false
      }
      this.allLineSelect()
    },
    deleteFilter () {
      let actualService = this.getActualService()
      switch (this.filterTypeGet) {
        case 'details':
          actualService.filterDetails.saveDefaultFilterData({})
          break
        case 'draft':
          actualService.filterDraft.saveDefaultFilterData({})
          break
        case 'group':
          actualService.filterGroup.saveDefaultFilterData({})
          break
        case 'list':
          actualService.filter.saveDefaultFilterData({})
          break
        default:
          actualService.filter.saveDefaultFilterData({})
          break
      }
      this.hasDefaultFilter = false
      this.$f7.modal({
        title: this.$t('administration.del_filter'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    getActualService () {
      let serviceName = {
        '9': this.$engine.pain08
      }
      return serviceName[this.serviceId]
    },
    saveDefaultFilterData () {
      let that = this

      let actualService = this.getActualService()

      let defaultFilter = {
        Status: this.Status
      }

      for (const property in this.statusList) {
        let Status = that.statusList[property]
        defaultFilter[property] = Status.state
      }

      switch (this.filterTypeGet) {
        case 'details':
          actualService.filterDetails.saveDefaultFilterData(defaultFilter)
          break
        case 'draft':
          actualService.filterDraft.saveDefaultFilterData(defaultFilter)
          break
        case 'group':
          actualService.filterGroup.saveDefaultFilterData(defaultFilter)
          break
        case 'list':
          actualService.filter.saveDefaultFilterData(defaultFilter)
          break
        default:
          actualService.filter.saveDefaultFilterData(defaultFilter)
          break
      }

      if (this.hasInputFilter) {
        this.hasDefaultFilter = true
      }

      that.$f7.modal({
        title: this.$i18n.t('filter.dflt_fltr_svd'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    selectAll() {
      for (let index = 0; index < this.statusList.length; index++) {
        this.statusList[index].state = (this.allcheckedValid) ? 1 : 0
      }
    },
    setDefaultFilter (defaultFilter) {
      for (const property in defaultFilter) {
        if (this.statusList[property] !== undefined) {
          // Set filter status values
          this.statusList[property].state = defaultFilter[property]
          if (defaultFilter[property] === 1) {
            this.hasDefaultFilter = true
          }
        } else {
          // Set filter other values
          if (property !== 'modeFilter') {
            this[property] = defaultFilter[property]
            if (this[property]) {
              this.hasDefaultFilter = true
            }
          }
        }
      }
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    updateCheckall() {
      if(this.statusList.length == this.statusList.length){
         this.allcheckedValid = 1
      }else{
         this.allcheckedValid = 0
      }
    }
  },
  watch: {
    hasDefaultFilter () {
      this.communicateChange()
    },
    Status () {
      this.communicateChange()
    },
    statusList: {
      deep: true,
      handler () {
        this.communicateChange()
      }
    }
  }
}
</script>
